var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  style: {
    stroke: "var(--iconBlue)",
    strokeWidth: "2 stroke-linejoin: round stroke-linecap: round"
  },
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 14H6v8h12v-8ZM6 9V2h12v7"
})));
SvgPrinter.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinter);
export default ForwardRef;